import React, { useState, useEffect, useCallback, useRef } from 'react';
import SelectColaborador from '../components/SelectColaborador';

// SDR — Listas de Prospecção: importa Excel (coluna A = nome, coluna B =
// telefone) e a SDR trabalha a fila marcando desfechos. O botão WhatsApp é
// só um link wa.me (nenhuma sessão de WhatsApp é conectada).

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, { headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(r => r.json());
const ehVagner = () => localStorage.getItem('nomeUsuario') === 'Vagner Freitas';
// Radar RPI: Vagner + consultores (cargo closer, ex.: Pedro)
const podeRadar = () => ehVagner() || (localStorage.getItem('cargoUsuario') || '').toLowerCase().includes('closer');

const dig = (s) => (s || '').replace(/\D/g, '');
const fmtDt = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)} ${iso.slice(11, 16)}` : '—';
const fmtAg = (d) => d ? `${d.slice(8, 10)}/${d.slice(5, 7)}${d.length > 10 ? ' ' + d.slice(11, 16) : ''}` : '';

const inp = { padding: '4px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', background: '#fff', height: 30, outline: 'none', boxSizing: 'border-box' };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
const card = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 8, padding: 12 };
const btnMini = { border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, padding: '3px 6px' };

// Mensagens prontas por gatilho do Radar RPI ({sdr} = primeiro nome de quem
// envia, {marca} = marca do processo). A SDR copia e cola no WhatsApp dela.
const MSG_RADAR = {
  sozinhos: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. Vimos que o pedido da marca *{marca}* foi publicado na Revista do INPI — parabéns pelo passo! 🎉 Um alerta importante: agora corre o prazo em que outras empresas podem apresentar oposição, e como o processo está sem procurador, ninguém está acompanhando isso por você. A gente faz esse acompanhamento. Posso te explicar como funciona?',
  exigencia: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. O INPI publicou uma EXIGÊNCIA no processo da marca *{marca}* e o prazo de 60 dias já está correndo — se não for cumprida, o pedido é arquivado. Nossa equipe resolve isso pra você. Posso te passar os detalhes?',
  indeferido: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. O pedido da marca *{marca}* foi INDEFERIDO pelo INPI, mas ainda cabe recurso — o prazo de 60 dias já está correndo. Já revertemos muitos casos assim. Quer que a gente analise o seu?',
  oposicao: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. Uma empresa apresentou OPOSIÇÃO contra a marca *{marca}* no INPI. São 60 dias pra apresentar a defesa — sem ela, o risco de perder a marca é grande. Podemos cuidar disso pra você. Posso explicar?',
  deferido: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. Ótima notícia: a marca *{marca}* foi DEFERIDA pelo INPI! 🎉 Falta só o pagamento da taxa de concessão em até 60 dias — muita gente perde o registro nessa última etapa. Quer ajuda pra concluir com segurança?',
  expirado: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. O registro da marca *{marca}* consta como expirado no INPI — a proteção acabou e ela pode ser registrada por outra pessoa. Dá pra regularizar. Posso te mostrar o caminho?',
  perdido: 'Olá! Aqui é a {sdr}, da Preserva Marcas®. O pedido da marca *{marca}* foi arquivado no INPI (exigência não cumprida ou falta de pagamento). A boa notícia: dá pra depositar de novo do jeito certo. Quer que a gente cuide disso?',
};

const STATUS_INFO = {
  novo:          { label: 'Novo',            bg: '#eff6ff', cor: '#1d4ed8' },
  aguardando:    { label: 'Aguardando retorno ⏳', bg: '#e0f2fe', cor: '#0369a1' },
  sem_resposta:  { label: 'Sem resposta',    bg: '#fef9c3', cor: '#854d0e' },
  agendado:      { label: 'Agendado 📅',     bg: '#ede9fe', cor: '#6d28d9' },
  oportunidade:  { label: 'Oportunidade ✓',  bg: '#dcfce7', cor: '#15803d' },
  sem_interesse: { label: 'Sem interesse',   bg: '#fee2e2', cor: '#991b1b' },
  perdido:       { label: 'Perdido s/ contato', bg: '#f3f4f6', cor: '#6b7280' },
};

export default function Sdr() {
  const [listas, setListas] = useState(null);
  const [listaSel, setListaSel] = useState(null);
  const [contatos, setContatos] = useState(null);
  const [busca, setBusca] = useState('');
  const [filtro, setFiltro] = useState('trabalhar');
  const [modalImportar, setModalImportar] = useState(false);
  const [modalRadar, setModalRadar] = useState(false);
  const [modalMaps, setModalMaps] = useState(false); // lista do Google Maps (só Vagner)
  const [buscaGlobal, setBuscaGlobal] = useState('');
  const [modalBusca, setModalBusca] = useState(false);
  const [modalOportunidade, setModalOportunidade] = useState(null); // contato
  const [modalAgendar, setModalAgendar] = useState(null); // contato
  const [verArquivadas, setVerArquivadas] = useState(false);
  const [copiadoId, setCopiadoId] = useState(null); // feedback do 💬 mensagem
  const [procCopiado, setProcCopiado] = useState(null); // feedback do 📋 copiar processo
  const [enriquecendo, setEnriquecendo] = useState(null); // progresso da busca de telefones
  const enriquecerTimer = useRef(null);
  useEffect(() => () => clearInterval(enriquecerTimer.current), []);
  const [vista, setVista] = useState('listas'); // 'listas' | 'painel'
  // Abas por SDR (Bianca, Tacila…): cada uma enxerga as próprias listas.
  // As abas nascem do cargo SDR no cadastro de usuários + donas de listas.
  const [sdrsEquipe, setSdrsEquipe] = useState([]);
  const [cargoPorNome, setCargoPorNome] = useState({});
  const [abaSdr, setAbaSdr] = useState(null);
  // Modo Visor: um contato por vez + pilha "aguardando retorno" — validado
  // pelo Vagner e liberado pra equipe toda em 21/07 (treinamento das SDRs)
  const [modoVisor, setModoVisor] = useState(true);
  const [, setTick] = useState(0); // re-render dos relógios da pilha

  const carregarListas = useCallback(async () => {
    try { const d = await apiGet('sdr/listas'); setListas(Array.isArray(d) ? d : []); } catch { setListas([]); }
  }, []);
  const carregarContatos = useCallback(async (id) => {
    setContatos(null);
    try { const d = await apiGet(`sdr/listas/${id}/contatos`); setContatos(d.contatos || []); } catch { setContatos([]); }
  }, []);

  useEffect(() => { carregarListas(); }, [carregarListas]);

  // Visor: relógios andam a cada 20s; a cada 60s recarrega silenciosamente
  // (pega os contatos que o servidor virou pra "sem resposta" após os 30min).
  // Fica DEPOIS de carregarListas pra não referenciar antes de inicializar.
  useEffect(() => {
    if (!listaSel || !modoVisor) return;
    const id = listaSel._id;
    const tRelogio = setInterval(() => setTick(t => t + 1), 20000);
    const tRecarga = setInterval(async () => {
      try { const d = await apiGet(`sdr/listas/${id}/contatos`); setContatos(d.contatos || []); } catch {}
      carregarListas();
    }, 60000);
    return () => { clearInterval(tRelogio); clearInterval(tRecarga); };
  }, [listaSel, modoVisor, carregarListas]);

  // ?lista=<id>: o bloco RPI do Closer abre direto na fila certa
  useEffect(() => {
    const alvo = new URLSearchParams(window.location.search).get('lista');
    if (!alvo || !listas || listaSel) return;
    const l = listas.find(x => x._id === alvo);
    if (l) { setListaSel(l); setBusca(''); setFiltro('trabalhar'); carregarContatos(l._id); }
  }, [listas]);

  useEffect(() => {
    apiGet('usuarios').then(us => {
      if (!Array.isArray(us)) return;
      // Toda a equipe vira aba (Clau é IA, fica de fora): SDRs primeiro,
      // depois os demais em ordem alfabética
      const pessoas = us.filter(u => u.nome && u.nome !== 'Clau');
      const ehSdr = (u) => (u.cargo || '').toLowerCase().includes('sdr') ? 0 : 1;
      pessoas.sort((a, b) => ehSdr(a) - ehSdr(b) || a.nome.localeCompare(b.nome));
      setSdrsEquipe(pessoas.map(u => u.nome));
      setCargoPorNome(Object.fromEntries(pessoas.map(u => [u.nome, (u.cargo || '').toLowerCase()])));
    }).catch(() => {});
  }, []);

  const abrirLista = (l) => { setListaSel(l); setBusca(''); setFiltro('trabalhar'); carregarContatos(l._id); };

  async function desfecho(c, acao, extra = {}) {
    // Atualização otimista pra fila andar rápido
    setContatos(prev => prev.map(x => x._id === c._id ? {
      ...x,
      status: acao === 'tentativa' ? 'sem_resposta'
        : acao === 'trabalhado' ? 'aguardando'
        : acao === 'oportunidade' ? 'oportunidade'
        : acao === 'agendar' ? 'agendado'
        : acao === 'reabrir' ? 'novo'
        : acao,
      tentativas: (acao === 'tentativa' || acao === 'trabalhado') ? (x.tentativas || 0) + 1 : x.tentativas,
      ultima_tentativa: (acao === 'tentativa' || acao === 'trabalhado') ? new Date().toISOString() : x.ultima_tentativa,
      motivo: extra.motivo || (acao === 'reabrir' ? '' : x.motivo),
      agendado_para: acao === 'agendar' ? extra.data : acao === 'reabrir' ? '' : x.agendado_para,
    } : x));
    const r = await apiSend(`sdr/contatos/${c._id}/desfecho`, 'PUT', { acao, ...extra }).catch(() => null);
    carregarListas();
    return r; // a oportunidade devolve oportunidade_id (usado pra tarefa junto)
  }

  function semInteresse(c) {
    const motivo = window.prompt('Motivo (opcional): preço, já tem marca, outro…') || '';
    desfecho(c, 'sem_interesse', { motivo });
  }

  // Leads do Radar RPI chegam sem telefone — a SDR acha e completa aqui
  async function editarTelefone(c) {
    const tel = window.prompt('Telefone do contato (com DDD):', c.telefone || '');
    if (tel === null) return;
    setContatos(prev => prev.map(x => x._id === c._id ? { ...x, telefone: tel.trim() } : x));
    await apiSend(`sdr/contatos/${c._id}/telefone`, 'PUT', { telefone: tel.trim() }).catch(() => {});
  }

  // Check visual "já chamei esse": marca a linha sem encerrar o contato
  async function alternarCheck(c) {
    const novo = !c.checado;
    setContatos(prev => prev.map(x => x._id === c._id ? { ...x, checado: novo } : x));
    await apiSend(`sdr/contatos/${c._id}/check`, 'PUT', { checado: novo }).catch(() => {});
  }

  // Copia a mensagem pronta do gatilho do Radar (a SDR cola no WhatsApp dela)
  function copiarMensagem(c) {
    const modelo = MSG_RADAR[c.radar_categoria] || MSG_RADAR.sozinhos;
    const sdrNome = (localStorage.getItem('nomeUsuario') || '').split(' ')[0];
    const msg = modelo.replace(/{sdr}/g, sdrNome).replace(/{marca}/g, c.marca || 'sua marca');
    const fallback = () => {
      const el = document.createElement('textarea');
      el.value = msg; document.body.appendChild(el); el.select();
      document.execCommand('copy'); document.body.removeChild(el);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(msg).catch(fallback);
    else fallback();
    setCopiadoId(c._id);
    setTimeout(() => setCopiadoId(null), 2000);
  }

  // Copia o telefone (só dígitos — pronto pra colar no discador/WhatsApp)
  const [telCopiado, setTelCopiado] = useState(null);
  function copiarTelefone(c) {
    const num = String(c.telefone || '').replace(/\D/g, '');
    const fallback = () => {
      const el = document.createElement('textarea');
      el.value = num; document.body.appendChild(el); el.select();
      document.execCommand('copy'); document.body.removeChild(el);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(num).catch(fallback);
    else fallback();
    setTelCopiado(c._id);
    setTimeout(() => setTelCopiado(null), 2000);
  }

  // Copia o nº do processo (pra colar na busca do INPI, no sistema ou no WhatsApp)
  function copiarProcesso(c) {
    const num = String(c.processo || '').trim();
    const fallback = () => {
      const el = document.createElement('textarea');
      el.value = num; document.body.appendChild(el); el.select();
      document.execCommand('copy'); document.body.removeChild(el);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(num).catch(fallback);
    else fallback();
    setProcCopiado(c._id);
    setTimeout(() => setProcCopiado(null), 2000);
  }

  // Verificação gratuita "tem WhatsApp?" (sessão principal) — só Vagner
  async function verificarWhatsApp() {
    const r = await apiSend(`sdr/listas/${listaSel._id}/verificar-whatsapp`, 'POST').catch(() => ({ erro: 'Falha ao iniciar' }));
    if (r.erro) return window.alert(r.erro);
    window.alert(`✓ Verificando ${r.iniciado} número(s) em segundo plano — os selos 💬 aparecem em ~1 minuto (atualize a lista).`);
  }

  // Busca automática de telefones da lista (Google Places) — só Vagner
  async function buscarTelefones() {
    const r = await apiSend(`sdr/listas/${listaSel._id}/enriquecer`, 'POST').catch(() => ({ erro: 'Falha ao iniciar' }));
    if (r.erro) return window.alert(r.erro);
    setEnriquecendo({ ativo: true, total: r.iniciado, feitos: 0, achados: 0 });
    clearInterval(enriquecerTimer.current);
    const listaId = listaSel._id;
    enriquecerTimer.current = setInterval(async () => {
      try {
        const st = await apiGet(`sdr/listas/${listaId}/enriquecer`);
        setEnriquecendo(st);
        if (!st.ativo) { clearInterval(enriquecerTimer.current); carregarContatos(listaId); }
      } catch {}
    }, 4000);
  }

  async function excluirLista(l) {
    if (!window.confirm(`Excluir a lista "${l.nome}" e todos os seus contatos?`)) return;
    await apiSend(`sdr/listas/${l._id}`, 'DELETE');
    if (listaSel?._id === l._id) { setListaSel(null); setContatos(null); }
    carregarListas();
  }

  // ── Vista: fila de uma lista ──
  if (listaSel) {
    const termo = busca.trim().toLowerCase();
    const filtrados = (contatos || []).filter(c => {
      if (filtro === 'trabalhar' && c.status !== 'novo') return false;
      if (filtro !== 'trabalhar' && filtro !== 'todos' && c.status !== filtro) return false;
      if (!termo) return true;
      return c.nome.toLowerCase().includes(termo) || dig(c.telefone).includes(dig(termo));
    });
    const cont = listas?.find(l => l._id === listaSel._id)?.contadores || {};
    const trabalhados = (cont.total || 0) - (cont.novo || 0);

    // Modo Visor: um contato por vez; pilha = quem já recebeu mensagem e
    // está aguardando retorno (30min → sem_resposta, via job do backend)
    const visorAtivo = modoVisor;
    const filaNovos = (contatos || []).filter(c => c.status === 'novo');
    const atualVisor = filaNovos[0] || null;
    const pilhaAguardando = (contatos || []).filter(c => c.status === 'aguardando')
      .sort((a, b) => String(b.ultima_tentativa || '').localeCompare(String(a.ultima_tentativa || '')));

    return (
      <div style={{ maxWidth: 1000, padding: 4 }}>
        {modalOportunidade && (
          <ModalOportunidade contato={modalOportunidade} onFechar={() => setModalOportunidade(null)}
            onConfirmar={async (closer, tarefa) => {
              const c = modalOportunidade;
              setModalOportunidade(null);
              const r = await desfecho(c, 'oportunidade', { closer });
              // Tarefa junto: nasce vinculada à oportunidade recém-criada
              if (tarefa && r?.oportunidade_id) {
                await apiSend('agenda', 'POST', { ...tarefa, oportunidade_id: r.oportunidade_id, oportunidade_nome: c.nome }).catch(() => {});
              }
            }} />
        )}
        {modalAgendar && (
          <ModalAgendar contato={modalAgendar} onFechar={() => setModalAgendar(null)}
            onConfirmar={(data) => { desfecho(modalAgendar, 'agendar', { data }); setModalAgendar(null); }} />
        )}
        {modalBusca && <ModalBuscaGlobal termoInicial={buscaGlobal} onFechar={() => { setModalBusca(false); setBuscaGlobal(''); carregarListas(); carregarContatos(listaSel._id); }} />}
        <button onClick={() => { setListaSel(null); carregarListas(); }} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>← Listas</button>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, margin: '4px 0 10px' }}>
          <div>
            <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>📞 {listaSel.nome}</h1>
            <div style={{ fontSize: 12, color: '#6b7280' }}>{listaSel.sdr ? `SDR: ${listaSel.sdr} · ` : ''}{cont.total || 0} contatos · {trabalhados} trabalhados · <span style={{ color: '#15803d', fontWeight: 600 }}>{cont.oportunidade || 0} oportunidades</span></div>
          </div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
            {ehVagner() && ['radar_rpi', 'orfaos'].includes(listaSel.origem) && (
              enriquecendo?.ativo
                ? <span style={{ fontSize: 12, color: '#0369a1', fontWeight: 700 }}>🔎 buscando {enriquecendo.feitos}/{enriquecendo.total} ({enriquecendo.achados} achados)…</span>
                : <>
                    {enriquecendo && !enriquecendo.ativo && enriquecendo.feitos > 0 && (
                      <span style={{ fontSize: 12, color: '#15803d', fontWeight: 700 }}>✓ {enriquecendo.achados}/{enriquecendo.total} telefones achados</span>
                    )}
                    <button onClick={buscarTelefones} title="Busca automática dos telefones no Google (Places)" style={{ background: '#fff', color: '#0369a1', border: '1px solid #7dd3fc', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>🔎 Buscar telefones</button>
                    <button onClick={verificarWhatsApp} title="Confere de graça (pelo nosso WhatsApp) quais números têm WhatsApp — selos 💬" style={{ background: '#fff', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>💬 Verificar WhatsApp</button>
                  </>
            )}
            <button onClick={() => setModoVisor(v => !v)} title={modoVisor ? 'Ver a lista completa' : 'Um contato por vez, com pilha de aguardando retorno'}
              style={{ background: modoVisor ? '#0a1628' : '#fff', color: modoVisor ? '#fff' : '#0a1628', border: '1px solid #0a1628', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
              {modoVisor ? '📋 Ver lista' : '🎯 Modo Visor'}
            </button>
            {!visorAtivo && <>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar nome ou telefone…" style={{ ...inp, width: 200 }} />
            <select value={filtro} onChange={e => setFiltro(e.target.value)} style={inp}>
              <option value="trabalhar">A trabalhar ({cont.novo || 0})</option>
              <option value="todos">Todos ({cont.total || 0})</option>
              <option value="aguardando">Aguardando retorno ({cont.aguardando || 0})</option>
              <option value="sem_resposta">Sem resposta ({cont.sem_resposta || 0})</option>
              <option value="agendado">Agendados ({cont.agendado || 0})</option>
              <option value="oportunidade">Oportunidades ({cont.oportunidade || 0})</option>
              <option value="sem_interesse">Sem interesse ({cont.sem_interesse || 0})</option>
              <option value="perdido">Perdidos ({cont.perdido || 0})</option>
            </select>
            </>}
          </div>
        </div>

        {visorAtivo ? (!contatos ? (
          <div style={{ ...card, textAlign: 'center', color: '#6b7280' }}>Carregando…</div>
        ) : (
          <>
            {atualVisor ? (
              <div style={{ ...card, border: '2px solid #0a1628', padding: 18 }}>
                <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 700, letterSpacing: 0.5, marginBottom: 6 }}>
                  🎯 CONTATO DA VEZ · fila: {filaNovos.length} restante{filaNovos.length === 1 ? '' : 's'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 19, fontWeight: 800, color: '#0a1628' }}>{atualVisor.nome}</span>
                  {atualVisor.ja_cliente && <span style={{ fontSize: 10, fontWeight: 700, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 4, padding: '0 6px' }}>⚠ JÁ É CLIENTE</span>}
                  {atualVisor.ja_crm && <span style={{ fontSize: 10, fontWeight: 700, color: '#7c3aed', background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 4, padding: '0 6px' }}>JÁ NO CRM</span>}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
                  {atualVisor.telefone ? (() => {
                    const d2 = dig(atualVisor.telefone);
                    const local = d2.length >= 10 ? d2.slice(-9) : d2;
                    const celular = local.length === 9 && local.startsWith('9');
                    return (
                      <span style={{ fontSize: 32, fontWeight: 700, color: '#374151', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        {atualVisor.telefone}
                        <span title={celular ? 'Celular' : 'Telefone fixo'} style={{ fontSize: 14 }}>{celular ? '📱' : '☎️'}</span>
                        {atualVisor.whatsapp === 'sim' && <span title="Tem WhatsApp (verificado)" style={{ fontSize: 10, fontWeight: 700, color: '#15803d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, padding: '0 4px' }}>💬 WA</span>}
                        {atualVisor.whatsapp === 'nao' && <span title="Número sem WhatsApp (verificado)" style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 4, padding: '0 4px', textDecoration: 'line-through' }}>WA</span>}
                      </span>
                    );
                  })() : (
                    atualVisor.radar
                      ? <a href={`https://www.google.com/search?q=${encodeURIComponent(`"${atualVisor.nome}"${atualVisor.uf ? ' ' + atualVisor.uf : ''} telefone whatsapp`)}`} target="_blank" rel="noreferrer"
                          style={{ fontSize: 12, color: '#0369a1', fontWeight: 700, textDecoration: 'none', border: '1px solid #bae6fd', borderRadius: 4, padding: '2px 8px', background: '#f0f9ff' }}>🔍 achar telefone</a>
                      : <span style={{ fontSize: 13, color: '#9ca3af' }}>sem telefone</span>
                  )}
                  {atualVisor.telefone && (
                    <button onClick={() => copiarTelefone(atualVisor)} title="Copiar o telefone (só números)"
                      style={{ background: telCopiado === atualVisor._id ? '#dcfce7' : '#f3f4f6', color: telCopiado === atualVisor._id ? '#15803d' : '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '2px 8px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                      {telCopiado === atualVisor._id ? '✓' : '📋'}
                    </button>
                  )}
                  {atualVisor.radar && <button onClick={() => editarTelefone(atualVisor)} title="Informar/corrigir o telefone" style={{ ...btnMini, fontSize: 14 }}>✏️</button>}
                </div>
                {atualVisor.radar && (
                  <div style={{ fontSize: 12, color: '#0369a1', marginTop: 5, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <span>📡 {atualVisor.radar_motivo}{atualVisor.marca ? <> · marca: <strong>{atualVisor.marca}</strong></> : ''}{atualVisor.processo ? <> · proc. <strong>{atualVisor.processo}</strong></> : ''}{atualVisor.cidade ? <> · 📍 <strong>{atualVisor.cidade}</strong>{atualVisor.uf ? `-${atualVisor.uf}` : ''}</> : (atualVisor.uf ? ` · ${atualVisor.uf}` : '')}</span>
                    {atualVisor.processo && (
                      <button onClick={() => copiarProcesso(atualVisor)} title="Copiar o número do processo"
                        style={{ background: procCopiado === atualVisor._id ? '#dcfce7' : '#f0f9ff', color: procCopiado === atualVisor._id ? '#15803d' : '#0369a1', border: '1px solid #bae6fd', borderRadius: 4, padding: '0 6px', fontSize: 10.5, fontWeight: 700, cursor: 'pointer' }}>
                        {procCopiado === atualVisor._id ? '✓ copiado' : '📋 copiar'}
                      </button>
                    )}
                  </div>
                )}
                {atualVisor.tentativas > 0 && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 3 }}>{atualVisor.tentativas} tentativa{atualVisor.tentativas > 1 ? 's' : ''} antes (última {fmtDt(atualVisor.ultima_tentativa)})</div>}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 14, flexWrap: 'wrap' }}>
                  {atualVisor.radar && (
                    <button onClick={() => copiarMensagem(atualVisor)} title="Copiar a mensagem pronta desse gatilho (cole no seu WhatsApp)"
                      style={{ background: copiadoId === atualVisor._id ? '#dcfce7' : '#fff', color: copiadoId === atualVisor._id ? '#15803d' : '#0369a1', border: `1px solid ${copiadoId === atualVisor._id ? '#bbf7d0' : '#7dd3fc'}`, borderRadius: 6, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                      {copiadoId === atualVisor._id ? '✓ copiada!' : '💬 mensagem'}
                    </button>
                  )}
                  <div style={{ flex: 1 }} />
                  <button onClick={() => setModalBusca(true)} title="Alguém respondeu no WhatsApp? Busca em todas as listas — e não achando, lança avulsa"
                    style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '9px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>✓ Oportunidade</button>
                  <button onClick={() => desfecho(atualVisor, 'trabalhado')} title="Mensagem enviada — o contato desce pra pilha e vem o próximo"
                    style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '9px 24px', fontSize: 14, fontWeight: 800, cursor: 'pointer' }}>Próximo ▶</button>
                </div>
              </div>
            ) : (
              <div style={{ ...card, textAlign: 'center', padding: 24 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#15803d' }}>🎉 Fila zerada — todos os contatos desta lista foram trabalhados!</div>
                {pilhaAguardando.length > 0 && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Ainda dá pra converter quem responder da pilha abaixo pelo botão ✓ Oportunidade.</div>}
                <div style={{ marginTop: 10 }}>
                  <button onClick={() => setModalBusca(true)} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>✓ Oportunidade</button>
                </div>
              </div>
            )}
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: '#0369a1', marginBottom: 6 }}>
                ⏳ Aguardando retorno ({pilhaAguardando.length}) <span style={{ color: '#9ca3af', fontWeight: 400 }}>— sem virar oportunidade em 30 min, passam sozinhos pra "Sem resposta"</span>
              </div>
              {pilhaAguardando.length === 0 ? (
                <div style={{ ...card, color: '#9ca3af', fontSize: 12, textAlign: 'center' }}>Ninguém aguardando — toque "Próximo ▶" pra empilhar quem você já chamou.</div>
              ) : (
                <div style={{ ...card, padding: 0, maxHeight: 320, overflowY: 'auto' }}>
                  {pilhaAguardando.map((c, i) => {
                    const min = Math.max(0, Math.floor((Date.now() - new Date(c.ultima_tentativa || 0).getTime()) / 60000));
                    const resta = Math.max(0, 30 - min);
                    const corRel = resta <= 5 ? '#dc2626' : resta <= 12 ? '#b45309' : '#0369a1';
                    return (
                      <div key={c._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 12px', borderBottom: i < pilhaAguardando.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{c.nome}</span>
                          {c.telefone && <span style={{ fontSize: 12, color: '#6b7280', marginLeft: 8 }}>{c.telefone}</span>}
                        </div>
                        <span style={{ fontSize: 11.5, fontWeight: 700, color: corRel, whiteSpace: 'nowrap' }}>
                          ⏱ há {min} min{resta > 0 ? ` · sem resposta em ${resta} min` : ' · virando "Sem resposta"…'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 8 }}>
              😴 Sem resposta: <strong>{cont.sem_resposta || 0}</strong> · ✓ Oportunidades: <strong style={{ color: '#15803d' }}>{cont.oportunidade || 0}</strong> · Sem interesse: <strong>{cont.sem_interesse || 0}</strong> — pra retrabalhar alguém, use "📋 Ver lista".
            </div>
          </>
        )) : !contatos ? (
          <div style={{ ...card, textAlign: 'center', color: '#6b7280' }}>Carregando…</div>
        ) : filtrados.length === 0 ? (
          <div style={{ ...card, textAlign: 'center', color: '#6b7280', padding: 30 }}>
            {filtro === 'trabalhar' ? '🎉 Fila zerada — todos os contatos desta lista foram trabalhados!' : 'Nenhum contato neste filtro.'}
          </div>
        ) : (
          <div style={{ ...card, padding: 0, maxHeight: 600, overflowY: 'auto' }}>
            {filtrados.map((c, i) => {
              const st = STATUS_INFO[c.status] || STATUS_INFO.novo;
              const aberto = c.status === 'novo';
              return (
                <div key={c._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', borderBottom: i < filtrados.length - 1 ? '1px solid #f3f4f6' : 'none', background: c.checado && aberto ? '#f0fdf4' : 'transparent' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{c.nome}</span>
                      {c.telefone
                        ? (() => {
                            const dig = c.telefone.replace(/\D/g, '');
                            const local = dig.length >= 10 ? dig.slice(-9) : dig; // parte do assinante
                            const celular = local.length === 9 && local.startsWith('9');
                            return (
                              <span style={{ fontSize: 12, color: '#6b7280', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                {c.telefone}
                                <span title={celular ? 'Celular' : 'Telefone fixo'} style={{ fontSize: 11 }}>{celular ? '📱' : '☎️'}</span>
                                {c.whatsapp === 'sim' && <span title="Tem WhatsApp (verificado)" style={{ fontSize: 10, fontWeight: 700, color: '#15803d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, padding: '0 4px' }}>💬 WA</span>}
                                {c.whatsapp === 'nao' && <span title="Número sem WhatsApp (verificado)" style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 4, padding: '0 4px', textDecoration: 'line-through' }}>WA</span>}
                              </span>
                            );
                          })()
                        : c.radar && (
                          <a href={`https://www.google.com/search?q=${encodeURIComponent(`"${c.nome}"${c.uf ? ' ' + c.uf : ''} telefone whatsapp`)}`} target="_blank" rel="noreferrer"
                            onClick={e => e.stopPropagation()}
                            style={{ fontSize: 11, color: '#0369a1', fontWeight: 600, textDecoration: 'none', border: '1px solid #bae6fd', borderRadius: 4, padding: '0 6px', background: '#f0f9ff' }}>🔍 achar telefone</a>
                        )}
                      {c.radar && <button onClick={() => editarTelefone(c)} title="Informar/corrigir o telefone" style={{ ...btnMini, padding: '0 4px' }}>✏️</button>}
                      {c.telefone && (
                        <button onClick={() => copiarTelefone(c)} title="Copiar o telefone (só números)"
                          style={{ background: telCopiado === c._id ? '#dcfce7' : '#f3f4f6', color: telCopiado === c._id ? '#15803d' : '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '0 6px', fontSize: 10.5, fontWeight: 700, cursor: 'pointer', lineHeight: '16px' }}>
                          {telCopiado === c._id ? '✓' : '📋'}
                        </button>
                      )}
                      {c.ja_cliente && <span style={{ fontSize: 10, fontWeight: 700, color: '#1d4ed8', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 4, padding: '0 6px' }}>⚠ JÁ É CLIENTE</span>}
                      {c.ja_crm && <span style={{ fontSize: 10, fontWeight: 700, color: '#7c3aed', background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 4, padding: '0 6px' }}>JÁ NO CRM</span>}
                    </div>
                    {c.radar && (
                      <div style={{ fontSize: 11, color: '#0369a1', marginTop: 1, display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                        <span>📡 {c.radar_motivo}{c.marca ? <> · marca: <strong>{c.marca}</strong></> : ''}{c.processo ? <> · proc. <strong>{c.processo}</strong></> : ''}{c.cidade ? <> · 📍 <strong>{c.cidade}</strong>{c.uf ? `-${c.uf}` : ''}</> : (c.uf ? ` · ${c.uf}` : '')}{c.processos > 1 ? ` · ${c.processos} processos` : ''}</span>
                        {c.processo && (
                          <button onClick={() => copiarProcesso(c)} title="Copiar o número do processo"
                            style={{ background: procCopiado === c._id ? '#dcfce7' : '#f0f9ff', color: procCopiado === c._id ? '#15803d' : '#0369a1', border: `1px solid ${procCopiado === c._id ? '#bbf7d0' : '#bae6fd'}`, borderRadius: 4, padding: '0 6px', fontSize: 10.5, fontWeight: 700, cursor: 'pointer', lineHeight: '16px' }}>
                            {procCopiado === c._id ? '✓ copiado' : '📋 copiar'}
                          </button>
                        )}
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>
                      <span style={{ background: st.bg, color: st.cor, borderRadius: 4, padding: '0 6px', fontWeight: 600 }}>{st.label}</span>
                      {c.tentativas > 0 && <span> · {c.tentativas} tentativa{c.tentativas > 1 ? 's' : ''} (última {fmtDt(c.ultima_tentativa)})</span>}
                      {c.status === 'agendado' && c.agendado_para && <span style={{ color: '#6d28d9', fontWeight: 600 }}> · retorno {fmtAg(c.agendado_para)}</span>}
                      {c.motivo && <span> · motivo: {c.motivo}</span>}
                    </div>
                  </div>
                  {aberto ? (
                    <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center' }}>
                      {c.radar && (
                        <button onClick={() => copiarMensagem(c)} title="Copiar a mensagem pronta desse gatilho (cole no seu WhatsApp)" style={{ background: copiadoId === c._id ? '#dcfce7' : '#fff', color: copiadoId === c._id ? '#15803d' : '#0369a1', border: `1px solid ${copiadoId === c._id ? '#bbf7d0' : '#bae6fd'}`, borderRadius: 5, padding: '4px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>{copiadoId === c._id ? '✓ copiada!' : '💬 mensagem'}</button>
                      )}
                      <button onClick={() => alternarCheck(c)} title={c.checado ? 'Desmarcar' : 'Marcar como já contatado (não encerra — só sinaliza a linha)'}
                        style={{ width: 22, height: 22, borderRadius: 5, border: `2px solid ${c.checado ? '#16a34a' : '#c8d0da'}`, background: c.checado ? '#16a34a' : '#fff', color: '#fff', fontSize: 13, fontWeight: 800, lineHeight: 1, cursor: 'pointer', padding: 0, flexShrink: 0 }}>
                        {c.checado ? '✓' : ''}
                      </button>
                      <button onClick={() => setModalOportunidade(c)} title="Cliente interessado — cria a oportunidade no CRM escolhendo o consultor" style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '4px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>✓ Oportunidade</button>
                      <button onClick={() => desfecho(c, 'tentativa')} title="Cliente não interagiu — registra a tentativa" style={{ background: '#fff', color: '#854d0e', border: '1px solid #fde68a', borderRadius: 5, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>Sem resposta</button>
                      <button onClick={() => setModalAgendar(c)} title="Cliente pediu contato mais pra frente — cria o retorno na sua Agenda" style={{ background: '#fff', color: '#6d28d9', border: '1px solid #ddd6fe', borderRadius: 5, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>📅 Agendar</button>
                      <button onClick={() => semInteresse(c)} style={{ background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 5, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>Sem interesse</button>
                      {(c.tentativas || 0) >= 3 && (
                        <button onClick={() => desfecho(c, 'perdido')} title="3+ tentativas sem retorno" style={{ background: '#f3f4f6', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: 5, padding: '4px 8px', fontSize: 11, cursor: 'pointer' }}>Marcar perdido</button>
                      )}
                    </div>
                  ) : (
                    <button onClick={() => desfecho(c, 'reabrir')} title="Voltar este contato para a fila" style={{ ...btnMini, color: '#6b7280' }}>↺ Reabrir</button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  // ── Vista: painel de eficiência ──
  if (vista === 'painel') return <PainelEficiencia onVoltar={() => setVista('listas')} />;

  // ── Vista: cards das listas, organizados em abas por pessoa ──
  // Ordem: SDRs primeiro (já vem ordenado do efeito), depois donas avulsas
  const donasExtras = [...new Set((listas || []).map(l => l.sdr).filter(Boolean))].filter(d => !sdrsEquipe.includes(d)).sort();
  const abas = [...sdrsEquipe, ...donasExtras];
  if ((listas || []).some(l => !l.sdr)) abas.push('Sem dona');
  const abaAtual = abaSdr && abas.includes(abaSdr)
    ? abaSdr
    : (abas.includes(localStorage.getItem('nomeUsuario')) ? localStorage.getItem('nomeUsuario') : abas[0]);
  const listasDaAba = (listas || []).filter(l => (l.sdr || 'Sem dona') === abaAtual);
  const ativas = listasDaAba.filter(l => !l.arquivada);
  const arquivadas = listasDaAba.filter(l => l.arquivada);

  async function arquivarLista(l, arquivada) {
    await apiSend(`sdr/listas/${l._id}/arquivar`, 'PUT', { arquivada }).catch(() => {});
    carregarListas();
  }

  // Saudadora (SDR Virtual): liga/desliga a lista na fila da ponte do celular
  async function toggleSaudadora(l) {
    const ligar = !l.virtual;
    if (ligar && !window.confirm(`Ligar a saudadora na lista "${l.nome}"?\n\nOs contatos NOVOS entram na fila do celular da SDR (teto 10/dia, 9h-18h, áudio de abordagem automático).`)) return;
    await apiSend(`sdr/listas/${l._id}/virtual`, 'PUT', { virtual: ligar }).catch(() => {});
    carregarListas();
  }

  const cardLista = (l) => {
    const c = l.contadores;
    const trabalhados = c.total - c.novo;
    const conv = trabalhados > 0 ? Math.round((c.oportunidade / trabalhados) * 100) : 0;
    const pct = (n) => c.total ? (n / c.total) * 100 : 0;
    return (
      <div key={l._id} style={{ ...card, cursor: 'pointer' }} onClick={() => abrirLista(l)}
        onMouseEnter={e => e.currentTarget.style.borderColor = '#0a1628'}
        onMouseLeave={e => e.currentTarget.style.borderColor = '#c8d0da'}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 6 }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#0a1628' }}>{l.arquivada ? '📦 ' : ''}{l.virtual ? '🤖 ' : ''}{l.nome}</div>
            <div style={{ fontSize: 11, color: '#6b7280' }}>{l.sdr || 'sem dona'} · {c.total} contatos{l.virtual ? ' · saudadora LIGADA' : ''}</div>
          </div>
          {/* Arquivar: Vagner em qualquer lista; SDR nas próprias. Excluir e Saudadora: só Vagner */}
          {(ehVagner() || l.sdr === localStorage.getItem('nomeUsuario')) && (
            <div style={{ display: 'flex', gap: 2 }}>
              {ehVagner() && <button onClick={e => { e.stopPropagation(); toggleSaudadora(l); }}
                title={l.virtual ? 'Saudadora LIGADA — clique pra desligar (a ponte para de abordar esta lista)' : 'Ligar a saudadora — o celular da SDR passa a abordar os contatos novos desta lista'}
                style={{ ...btnMini, color: l.virtual ? '#16a34a' : '#9ca3af', background: l.virtual ? '#dcfce7' : 'transparent', borderRadius: 6 }}>🤖</button>}
              {l.arquivada
                ? <button onClick={e => { e.stopPropagation(); arquivarLista(l, false); }} title="Desarquivar — volta pro dia a dia" style={{ ...btnMini, color: '#0a1628' }}>↩️</button>
                : <button onClick={e => { e.stopPropagation(); arquivarLista(l, true); }} title="Arquivar — sai da tela, mas mantém histórico e métricas" style={{ ...btnMini, color: '#6b7280' }}>📦</button>}
              {ehVagner() && <button onClick={e => { e.stopPropagation(); excluirLista(l); }} title="Excluir lista (apaga contatos e histórico — prefira arquivar)" style={{ ...btnMini, color: '#dc2626' }}>🗑️</button>}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', height: 8, borderRadius: 99, overflow: 'hidden', background: '#f3f4f6', margin: '10px 0 6px' }}>
          <div style={{ width: `${pct(c.oportunidade)}%`, background: '#16a34a' }} />
          <div style={{ width: `${pct(c.sem_interesse)}%`, background: '#dc2626', opacity: 0.65 }} />
          <div style={{ width: `${pct(c.perdido)}%`, background: '#9ca3af', opacity: 0.6 }} />
          <div style={{ width: `${pct(c.sem_resposta)}%`, background: '#f59e0b', opacity: 0.55 }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#6b7280', flexWrap: 'wrap', gap: 4 }}>
          <span><span style={{ color: '#15803d', fontWeight: 700 }}>{c.oportunidade}</span> oport. · <span style={{ color: '#991b1b' }}>{c.sem_interesse}</span> s/ interesse · {c.perdido} perdidos</span>
          <span>fila: <strong style={{ color: '#0a1628' }}>{c.novo}</strong>{trabalhados > 0 && <> · conversão <strong style={{ color: '#15803d' }}>{conv}%</strong></>}</span>
        </div>
      </div>
    );
  };

  return (
    <div style={{ maxWidth: 1000, padding: 4 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>📞 SDR — Listas de Prospecção</h1>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0' }}>Importe a planilha (coluna A = nome, coluna B = telefone) e trabalhe a fila marcando os desfechos.</p>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
          <input value={buscaGlobal} onChange={e => setBuscaGlobal(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && buscaGlobal.trim().length >= 3) setModalBusca(true); }}
            placeholder="🔍 Buscar nome ou telefone em todas as listas…"
            title="Acha um contato já trabalhado em qualquer lista pra dar outro destino"
            style={{ ...inp, width: 250 }} />
          <button onClick={() => buscaGlobal.trim().length >= 3 && setModalBusca(true)} style={{ background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 6, padding: '7px 12px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Buscar</button>
          {podeRadar() && <button onClick={() => setModalRadar(true)} title="Gatilhos comerciais da última RPI viram listas quentes" style={{ background: '#fff', color: '#0369a1', border: '1px solid #7dd3fc', borderRadius: 6, padding: '7px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>📡 Radar RPI</button>}
          {podeRadar() && <button onClick={() => setModalMaps(true)} title="Gera lista de estabelecimentos do Google Maps por segmento e bairro, com telefone" style={{ background: '#fff', color: '#0e7490', border: '1px solid #67e8f9', borderRadius: 6, padding: '7px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>🗺️ Google Maps</button>}
          <button onClick={() => setVista('painel')} style={{ background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 6, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>📈 Painel de eficiência</button>
          <button onClick={() => setModalImportar(true)} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>+ Importar lista</button>
        </div>
      </div>

      {/* Abas por SDR — cada uma com as próprias listas */}
      {abas.length > 0 && (
        <div style={{ display: 'flex', gap: 4, marginBottom: 14, borderBottom: '2px solid #c8d0da', flexWrap: 'wrap' }}>
          {abas.map(a => {
            const n = (listas || []).filter(l => (l.sdr || 'Sem dona') === a && !l.arquivada).length;
            const ativa = a === abaAtual;
            return (
              <button key={a} onClick={() => setAbaSdr(a)} style={{
                padding: '7px 16px', fontSize: 13, fontWeight: ativa ? 700 : 500,
                background: ativa ? '#0a1628' : '#e8edf2', color: ativa ? '#fff' : '#374151',
                border: 'none', borderRadius: '6px 6px 0 0', cursor: 'pointer', marginBottom: -2,
                borderBottom: ativa ? '2px solid #0a1628' : '2px solid transparent',
              }}>
                {a === 'Sem dona' ? '📂' : (cargoPorNome[a] || '').includes('sdr') ? '👩‍💼' : '👤'} {a}{n > 0 ? ` (${n})` : ''}
              </button>
            );
          })}
        </div>
      )}

      {!listas ? (
        <div style={{ ...card, textAlign: 'center', color: '#6b7280' }}>Carregando…</div>
      ) : ativas.length === 0 ? (
        <div style={{ ...card, textAlign: 'center', color: '#6b7280', padding: 36 }}>
          {arquivadas.length > 0
            ? <>Nenhuma lista ativa da <strong>{abaAtual}</strong> — as concluídas estão em <strong>📦 Arquivadas</strong>, logo abaixo.</>
            : abaAtual ? <>Nenhuma lista da <strong>{abaAtual}</strong> ainda. Clique em <strong>+ Importar lista</strong> e suba a planilha de empresas.</> : <>Nenhuma lista ainda. Clique em <strong>+ Importar lista</strong> e suba a planilha de empresas.</>}
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 10 }}>
          {ativas.map(cardLista)}
        </div>
      )}

      {/* Arquivadas: fora do dia a dia, mas com histórico e métricas vivos */}
      {arquivadas.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <button onClick={() => setVerArquivadas(v => !v)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 700, color: '#6b7280', padding: 0 }}>
            {verArquivadas ? '▾' : '▸'} 📦 Arquivadas ({arquivadas.length}) <span style={{ fontWeight: 400 }}>— continuam contando no painel</span>
          </button>
          {verArquivadas && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 10, marginTop: 8, opacity: 0.75 }}>
              {arquivadas.map(cardLista)}
            </div>
          )}
        </div>
      )}

      {modalImportar && <ModalImportar sdrPadrao={abaAtual !== 'Sem dona' ? abaAtual : ''} onFechar={() => setModalImportar(false)} onImportado={() => { setModalImportar(false); carregarListas(); }} />}
      {modalRadar && <ModalRadar sdrPadrao={abaAtual !== 'Sem dona' ? abaAtual : ''} onFechar={() => setModalRadar(false)} onGerado={() => { setModalRadar(false); carregarListas(); }} />}
      {modalMaps && <ModalMaps
        sdrPadrao={ehVagner() ? (abaAtual !== 'Sem dona' ? abaAtual : '') : localStorage.getItem('nomeUsuario')}
        sdrs={ehVagner()
          ? sdrsEquipe.filter(n => (cargoPorNome[n] || '').includes('sdr') || n === 'Vagner Freitas')
          : [localStorage.getItem('nomeUsuario')]}
        onFechar={() => setModalMaps(false)} onGerado={() => { setModalMaps(false); carregarListas(); }} />}
      {modalBusca && <ModalBuscaGlobal termoInicial={buscaGlobal} onFechar={() => { setModalBusca(false); carregarListas(); }} />}
    </div>
  );
}

// ── Painel de eficiência (etapa 2) ─────────────────────
// Produtividade por SDR (meta diária), conversão contato→oportunidade e
// contato→GANHO (ponta a ponta, cruzando com o CRM) e comparativo entre listas.

const PERIODOS = [
  { v: 'hoje', label: 'Hoje' },
  { v: 'ontem', label: 'Ontem' },
  { v: '7', label: '7 dias' },
  { v: '30', label: '30 dias' },
  { v: '90', label: '90 dias' },
  { v: '0', label: 'Tudo' },
];
// hoje/ontem viram ?periodo=, números viram ?dias=
const queryPeriodo = (p) => (['hoje', 'ontem'].includes(p) ? `periodo=${p}` : `dias=${p}`);

const th = { padding: '6px 10px', fontSize: 11, fontWeight: 700, color: '#6b7280', textAlign: 'left', borderBottom: '2px solid #e5e7eb', whiteSpace: 'nowrap' };
const td = { padding: '6px 10px', fontSize: 12.5, color: '#374151', borderBottom: '1px solid #f3f4f6', whiteSpace: 'nowrap' };

// Exportado: também é usado na aba "SDR Analitics" dos Relatórios (só Vagner).
// Sem onVoltar, renderiza embutido (sem botão ← Listas). sdrFiltro restringe
// tudo a uma SDR ('' = todas).
export function PainelEficiencia({ onVoltar, sdrFiltro }) {
  const [periodo, setPeriodo] = useState('30');
  const [dados, setDados] = useState(null);
  const [meta, setMeta] = useState(() => parseInt(localStorage.getItem('sdrMetaDiaria')) || 30);

  useEffect(() => {
    setDados(null);
    apiGet(`sdr/metricas?${queryPeriodo(periodo)}${sdrFiltro ? `&sdr=${encodeURIComponent(sdrFiltro)}` : ''}`).then(setDados).catch(() => setDados({ erro: true }));
  }, [periodo, sdrFiltro]);

  function mudarMeta(v) {
    const n = Math.max(1, parseInt(v) || 30);
    setMeta(n);
    localStorage.setItem('sdrMetaDiaria', String(n));
  }

  const g = dados?.geral;
  const maxDia = Math.max(1, ...(dados?.ultimos14 || []).map(d => d.total));

  const cardKpi = (rotulo, valor, extra, cor) => (
    <div style={{ ...card, flex: 1, minWidth: 130, textAlign: 'center', padding: '10px 8px' }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#6b7280' }}>{rotulo}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: cor || '#0a1628', lineHeight: 1.2 }}>{valor}</div>
      {extra && <div style={{ fontSize: 11, color: '#9ca3af' }}>{extra}</div>}
    </div>
  );

  return (
    <div style={{ maxWidth: 1000, padding: 4 }}>
      {onVoltar && <button onClick={onVoltar} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>← Listas</button>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, margin: '4px 0 12px' }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>📈 Painel de eficiência — SDR</h1>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0' }}>Produtividade, conversão em oportunidade e conversão em <strong>GANHO</strong> (cruzando com o CRM).</p>
        </div>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {PERIODOS.map(p => (
            <button key={p.v} onClick={() => setPeriodo(p.v)}
              style={{ padding: '5px 12px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid', borderColor: periodo === p.v ? '#0a1628' : '#c8d0da', background: periodo === p.v ? '#0a1628' : '#fff', color: periodo === p.v ? '#fff' : '#374151' }}>
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {!dados ? (
        <div style={{ ...card, textAlign: 'center', color: '#6b7280' }}>Calculando…</div>
      ) : dados.erro ? (
        <div style={{ ...card, textAlign: 'center', color: '#dc2626' }}>Não consegui carregar as métricas. Tente de novo.</div>
      ) : (
        <>
          {/* KPIs gerais do período */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
            {cardKpi('Contatos trabalhados', g.trabalhados, `${g.tentativas} tentativas`)}
            {cardKpi('Oportunidades', g.oportunidades, `${g.conv_oportunidade}% dos trabalhados`, '#15803d')}
            {cardKpi('Ganhos (fecharam)', g.ganhos, `${g.conv_ganho}% ponta a ponta`, '#1d4ed8')}
            {cardKpi('Sem interesse', g.sem_interesse, `${g.perdidos} perdidos`, '#991b1b')}
            {cardKpi('Fila aberta (hoje)', g.fila_total, 'contatos novos')}
          </div>

          {/* Atividade dos últimos 14 dias */}
          <div style={{ ...card, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Atividade — últimos 14 dias <span style={{ fontWeight: 400, color: '#9ca3af' }}>(contatos tocados por dia)</span></div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 70 }}>
              {dados.ultimos14.map(d => (
                <div key={d.dia} title={`${d.dia.slice(8, 10)}/${d.dia.slice(5, 7)}: ${d.total}`} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  {d.total > 0 && <span style={{ fontSize: 9, color: '#6b7280', fontWeight: 600 }}>{d.total}</span>}
                  <div style={{ width: '100%', borderRadius: '3px 3px 0 0', background: d.total ? '#0a1628' : '#f3f4f6', height: `${Math.max(3, (d.total / maxDia) * 52)}px`, opacity: d.total ? 0.85 : 1 }} />
                  <span style={{ fontSize: 9, color: '#9ca3af' }}>{d.dia.slice(8, 10)}/{d.dia.slice(5, 7)}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Por SDR */}
          <div style={{ ...card, padding: 0, marginBottom: 12, overflowX: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px 4px' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>Por SDR <span style={{ fontWeight: 400, color: '#9ca3af' }}>(no período)</span></div>
              <label style={{ fontSize: 11, color: '#6b7280' }}>Meta diária:{' '}
                <input type="number" min="1" value={meta} onChange={e => mudarMeta(e.target.value)} style={{ ...inp, width: 56, height: 24, fontSize: 12, textAlign: 'center' }} /> contatos
              </label>
            </div>
            {dados.sdrs.length === 0 ? (
              <div style={{ padding: '16px 12px', fontSize: 12, color: '#6b7280' }}>Nenhuma atividade registrada no período. As ações da fila (WhatsApp, tentativa, oportunidade…) passam a contar a partir de agora.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  <th style={th}>SDR</th><th style={th}>Trabalhados</th><th style={{ ...th, minWidth: 150 }}>Média/dia (meta {meta})</th>
                  <th style={th}>Tentativas</th><th style={th}>Oportunidades</th><th style={th}>Conv.</th>
                  <th style={th}>Ganhos</th><th style={th}>Conv. ganho</th><th style={th}>S/ interesse</th><th style={th}>Perdidos</th>
                </tr></thead>
                <tbody>
                  {dados.sdrs.map(s => {
                    const pctMeta = Math.min(100, (s.media_dia / meta) * 100);
                    const bateu = s.media_dia >= meta;
                    return (
                      <tr key={s.sdr}>
                        <td style={{ ...td, fontWeight: 700, color: '#0a1628' }}>{s.sdr}</td>
                        <td style={td}>{s.trabalhados} <span style={{ color: '#9ca3af', fontSize: 11 }}>em {s.dias_ativos} dia{s.dias_ativos !== 1 ? 's' : ''}</span></td>
                        <td style={td}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div style={{ flex: 1, height: 8, borderRadius: 99, background: '#f3f4f6', overflow: 'hidden' }}>
                              <div style={{ width: `${pctMeta}%`, height: '100%', background: bateu ? '#16a34a' : pctMeta >= 60 ? '#f59e0b' : '#dc2626' }} />
                            </div>
                            <span style={{ fontSize: 12, fontWeight: 700, color: bateu ? '#15803d' : '#374151' }}>{s.media_dia}</span>
                          </div>
                        </td>
                        <td style={td}>{s.tentativas}</td>
                        <td style={{ ...td, fontWeight: 700, color: '#15803d' }}>{s.oportunidades}</td>
                        <td style={td}>{s.conv_oportunidade}%</td>
                        <td style={{ ...td, fontWeight: 700, color: '#1d4ed8' }}>{s.ganhos}</td>
                        <td style={td}>{s.conv_ganho}%</td>
                        <td style={{ ...td, color: '#991b1b' }}>{s.sem_interesse}</td>
                        <td style={td}>{s.perdidos}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          {/* Comparativo entre listas */}
          <div style={{ ...card, padding: 0, overflowX: 'auto' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', padding: '10px 12px 4px' }}>Comparativo entre listas <span style={{ fontWeight: 400, color: '#9ca3af' }}>(estado atual — melhores segmentos primeiro)</span></div>
            {dados.listas.length === 0 ? (
              <div style={{ padding: '16px 12px', fontSize: 12, color: '#6b7280' }}>Nenhuma lista importada ainda.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr>
                  <th style={th}>Lista</th><th style={th}>SDR</th><th style={th}>Contatos</th><th style={th}>Trabalhados</th><th style={th}>Fila</th>
                  <th style={th}>Oportunidades</th><th style={th}>Conv.</th><th style={th}>Ganhos</th><th style={th}>Conv. ganho</th><th style={th}>S/ interesse</th>
                </tr></thead>
                <tbody>
                  {dados.listas.map((l, i) => (
                    <tr key={l.lista} style={i === 0 && l.oportunidades > 0 ? { background: '#f0fdf4' } : undefined}>
                      <td style={{ ...td, fontWeight: 700, color: '#0a1628' }}>{i === 0 && l.oportunidades > 0 ? '🏆 ' : ''}{l.lista}</td>
                      <td style={td}>{l.sdr || '—'}</td>
                      <td style={td}>{l.total}</td>
                      <td style={td}>{l.trabalhados}</td>
                      <td style={td}>{l.fila}</td>
                      <td style={{ ...td, fontWeight: 700, color: '#15803d' }}>{l.oportunidades}</td>
                      <td style={{ ...td, fontWeight: 700 }}>{l.conv_oportunidade}%</td>
                      <td style={{ ...td, color: '#1d4ed8', fontWeight: 700 }}>{l.ganhos}</td>
                      <td style={td}>{l.conv_ganho}%</td>
                      <td style={{ ...td, color: '#991b1b' }}>{l.sem_interesse}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {dados.listas.length > 1 && (
              <div style={{ fontSize: 11, color: '#6b7280', padding: '6px 12px 10px' }}>
                💡 Use a conversão por lista pra escolher os próximos segmentos: lista que converte mais merece mais contatos.
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

// ── Modal: criar oportunidade (mostra a SDR que gera e escolhe o consultor) ──
function ModalOportunidade({ contato, onFechar, onConfirmar }) {
  const [closer, setCloser] = useState('');
  const [erro, setErro] = useState('');
  // Tarefa criada junto com a oportunidade (mesmo esquema do CRM)
  const [tarefa, setTarefa] = useState(null);
  const sdrLogada = localStorage.getItem('nomeUsuario') || '';

  function confirmar() {
    if (!closer) return setErro('Escolha o consultor que vai receber a oportunidade.');
    if (tarefa && !tarefa.descricao.trim()) return setErro('Descreva a tarefa — ou remova a seção 📝 no ✕.');
    const t = tarefa && tarefa.descricao.trim() ? {
      descricao: tarefa.descricao.trim(),
      data_agendada: tarefa.data ? (tarefa.hora ? `${tarefa.data}T${tarefa.hora}` : tarefa.data) : '',
      destinado_a: tarefa.destinado_a,
      favorita: tarefa.favorita,
      urgente: tarefa.urgente,
    } : null;
    onConfirmar(closer, t);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 400, maxWidth: '94%', maxHeight: '90vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 4px' }}>✓ Criar oportunidade</h2>
        <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>
          <strong>{contato.nome}</strong>{contato.telefone ? ` · ${contato.telefone}` : ''}
        </div>
        <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '8px 12px', fontSize: 12.5, color: '#166534', marginBottom: 12 }}>
          SDR que gerou: <strong>{sdrLogada}</strong> — fica registrada na oportunidade.
        </div>
        <label style={lbl}>Consultor (closer) que vai atender <span style={{ color: '#dc2626' }}>*</span></label>
        <SelectColaborador apenasClosers value={closer} onChange={v => { setCloser(v); setErro(''); }} placeholder="Escolha o consultor…" style={{ marginBottom: 10, height: 34, fontSize: 13 }} />

        {/* Tarefa junto — já nasce vinculada à oportunidade criada */}
        {tarefa === null ? (
          <button type="button"
            onClick={() => setTarefa({ descricao: '', data: '', hora: '', destinado_a: closer || sdrLogada, favorita: false, urgente: false })}
            style={{ width: '100%', background: '#f9fafb', border: '1px dashed #c8d0da', borderRadius: 6, padding: '8px 12px', fontSize: 12.5, fontWeight: 600, color: '#374151', cursor: 'pointer', textAlign: 'left', marginBottom: 10, boxSizing: 'border-box' }}>
            📝 + Adicionar tarefa junto <span style={{ fontWeight: 400, color: '#9ca3af' }}>(já nasce vinculada à oportunidade)</span>
          </button>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 10, background: '#f9fafb', display: 'grid', gap: 8, marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>📝 Tarefa da oportunidade</span>
              <button type="button" onClick={() => { setTarefa(null); setErro(''); }} title="Remover a tarefa" style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: 14, cursor: 'pointer', lineHeight: 1 }}>✕</button>
            </div>
            <div>
              <label style={lbl}>Descrição *</label>
              <textarea value={tarefa.descricao} onChange={e => { setTarefa(t => ({ ...t, descricao: e.target.value })); setErro(''); }} rows={2}
                placeholder="Ex.: ligar amanhã pra apresentar proposta…"
                style={{ width: '100%', resize: 'vertical', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 86px', gap: 8 }}>
              <div>
                <label style={lbl}>Data</label>
                <input type="date" value={tarefa.data} onChange={e => setTarefa(t => ({ ...t, data: e.target.value }))} style={{ ...inp, width: '100%' }} />
              </div>
              <div>
                <label style={lbl}>Hora</label>
                <input type="time" value={tarefa.hora} onChange={e => setTarefa(t => ({ ...t, hora: e.target.value }))} style={{ ...inp, width: '100%' }} />
              </div>
            </div>
            <div>
              <label style={lbl}>Destinado a</label>
              <SelectColaborador value={tarefa.destinado_a} onChange={v => setTarefa(t => ({ ...t, destinado_a: v }))} placeholder="Selecione…" style={{ height: 30, fontSize: 13 }} />
            </div>
            <div>
              <button type="button" onClick={() => setTarefa(t => ({ ...t, favorita: !t.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia"
                style={{ background: tarefa.favorita ? '#fffbeb' : '#fff', color: tarefa.favorita ? '#b45309' : '#6b7280', border: `1px solid ${tarefa.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                {tarefa.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}
              </button>
              <button type="button" onClick={() => setTarefa(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: tarefa.urgente ? '#fee2e2' : '#fff', color: tarefa.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${tarefa.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefa.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
            </div>
          </div>
        )}

        {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={confirmar} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Criar oportunidade</button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: agendar retorno (cria a tarefa na Agenda da SDR) ──
function ModalAgendar({ contato, onFechar, onConfirmar }) {
  const [data, setData] = useState('');
  const [hora, setHora] = useState('');
  const [erro, setErro] = useState('');
  const hojeStr = new Date(Date.now() - 3 * 3600000).toISOString().slice(0, 10);

  function confirmar() {
    if (!data) return setErro('Escolha a data do retorno.');
    onConfirmar(hora ? `${data}T${hora}` : data);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 400, maxWidth: '94%', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 4px' }}>📅 Agendar retorno</h2>
        <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>
          <strong>{contato.nome}</strong>{contato.telefone ? ` · ${contato.telefone}` : ''}
        </div>
        <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 6, padding: '8px 12px', fontSize: 12.5, color: '#5b21b6', marginBottom: 12 }}>
          O retorno entra na <strong>sua Agenda</strong> na data escolhida, com o nome e o telefone do cliente.
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
          <div>
            <label style={lbl}>Data do retorno <span style={{ color: '#dc2626' }}>*</span></label>
            <input type="date" min={hojeStr} value={data} onChange={e => { setData(e.target.value); setErro(''); }} style={{ ...inp, width: '100%' }} />
          </div>
          <div>
            <label style={lbl}>Hora (opcional)</label>
            <input type="time" value={hora} onChange={e => setHora(e.target.value)} style={{ ...inp, width: '100%' }} />
          </div>
        </div>
        {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={confirmar} style={{ background: '#6d28d9', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Agendar</button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: busca global — acha contato em QUALQUER lista e dá outro destino ──
function ModalBuscaGlobal({ termoInicial, onFechar }) {
  const [termo, setTermo] = useState(termoInicial || '');
  const [resultados, setResultados] = useState(null);
  const [erro, setErro] = useState('');
  const [modalOp, setModalOp] = useState(null); // contato → ModalOportunidade
  const [modalAg, setModalAg] = useState(null); // contato → ModalAgendar
  const [modalAvulsa, setModalAvulsa] = useState(false); // ➕ oportunidade avulsa (fora das listas)

  const [jaBuscou, setJaBuscou] = useState(false);
  const buscar = useCallback(async (q) => {
    if ((q || '').trim().length < 3) return setErro('Digite pelo menos 3 caracteres.');
    setErro('');
    setJaBuscou(true);
    setResultados(null);
    try {
      const d = await apiGet(`sdr/contatos/buscar?q=${encodeURIComponent(q.trim())}`);
      if (d.erro) throw new Error(d.erro);
      setResultados(d.contatos);
    } catch (e) { setErro(e.message); setResultados([]); }
  }, []);
  // Abre já buscando quando veio termo; vazio, espera a SDR digitar
  useEffect(() => { if ((termoInicial || '').trim().length >= 3) buscar(termoInicial); }, [termoInicial, buscar]);

  // Novo destino direto da busca (atualiza a linha na hora)
  async function agir(c, acao, extra = {}) {
    setResultados(prev => prev.map(x => x._id === c._id ? {
      ...x,
      status: acao === 'tentativa' ? 'sem_resposta' : acao === 'oportunidade' ? 'oportunidade' : acao === 'agendar' ? 'agendado' : acao === 'reabrir' ? 'novo' : acao,
      agendado_para: acao === 'agendar' ? extra.data : acao === 'reabrir' ? '' : x.agendado_para,
      motivo: extra.motivo || (acao === 'reabrir' ? '' : x.motivo),
    } : x));
    const r = await apiSend(`sdr/contatos/${c._id}/desfecho`, 'PUT', { acao, ...extra }).catch(() => null);
    return r; // a oportunidade devolve oportunidade_id (usado pra tarefa junto)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 720, maxWidth: '96%', maxHeight: '88vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        {modalOp && <ModalOportunidade contato={modalOp} onFechar={() => setModalOp(null)} onConfirmar={async (closer, tarefa) => {
          const c = modalOp;
          setModalOp(null);
          const r = await agir(c, 'oportunidade', { closer });
          if (tarefa && r?.oportunidade_id) {
            await apiSend('agenda', 'POST', { ...tarefa, oportunidade_id: r.oportunidade_id, oportunidade_nome: c.nome }).catch(() => {});
          }
        }} />}
        {modalAg && <ModalAgendar contato={modalAg} onFechar={() => setModalAg(null)} onConfirmar={(data) => { agir(modalAg, 'agendar', { data }); setModalAg(null); }} />}
        {modalAvulsa && <ModalOpAvulsa termo={termo} onFechar={() => setModalAvulsa(false)} onCriada={() => { setModalAvulsa(false); onFechar(); }} />}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>🔍 Busca em todas as listas</h2>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
        </div>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 10px' }}>Ache um contato já trabalhado — em qualquer lista, de qualquer SDR — e dê outro destino.</p>
        <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
          <input value={termo} onChange={e => setTermo(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') buscar(termo); }}
            placeholder="Nome ou telefone…" autoFocus style={{ ...inp, flex: 1 }} />
          <button onClick={() => buscar(termo)} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Buscar</button>
        </div>
        {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}

        {!jaBuscou ? (
          <div style={{ textAlign: 'center', color: '#9ca3af', padding: 20, fontSize: 13 }}>Digite o número (ou nome) de quem respondeu e toque Buscar.</div>
        ) : !resultados ? (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: 20, fontSize: 13 }}>Buscando…</div>
        ) : resultados.length === 0 ? (
          !erro && (
            <div style={{ textAlign: 'center', padding: 18, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d', marginBottom: 8 }}>Esse contato não está em nenhuma lista.</div>
              <button onClick={() => setModalAvulsa(true)}
                style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                ➕ Lançar de forma avulsa
              </button>
            </div>
          )
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            {resultados.map((c, i) => {
              const st = STATUS_INFO[c.status] || STATUS_INFO.novo;
              return (
                <div key={c._id} style={{ padding: '8px 12px', borderBottom: i < resultados.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{c.nome}</span>
                    {c.telefone && <span style={{ fontSize: 12, color: '#6b7280' }}>{c.telefone}</span>}
                    <span style={{ background: st.bg, color: st.cor, borderRadius: 4, padding: '0 6px', fontSize: 10.5, fontWeight: 600 }}>{st.label}</span>
                    {c.status === 'agendado' && c.agendado_para && <span style={{ fontSize: 11, color: '#6d28d9', fontWeight: 600 }}>retorno {fmtAg(c.agendado_para)}</span>}
                  </div>
                  <div style={{ fontSize: 11, color: '#9ca3af', margin: '1px 0 5px' }}>
                    📋 {c.lista_nome}{c.lista_sdr ? ` · dona: ${c.lista_sdr}` : ''}
                    {c.tentativas > 0 && <span> · {c.tentativas} tentativa{c.tentativas > 1 ? 's' : ''}</span>}
                    {c.motivo && <span> · motivo: {c.motivo}</span>}
                    {c.radar && <span> · 📡 {c.radar_motivo}</span>}
                  </div>
                  <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                    <button onClick={() => setModalOp(c)} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '3px 9px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>✓ Oportunidade</button>
                    <button onClick={() => setModalAg(c)} style={{ background: '#fff', color: '#6d28d9', border: '1px solid #ddd6fe', borderRadius: 5, padding: '3px 8px', fontSize: 11, cursor: 'pointer' }}>📅 Agendar</button>
                    <button onClick={() => agir(c, 'tentativa')} style={{ background: '#fff', color: '#854d0e', border: '1px solid #fde68a', borderRadius: 5, padding: '3px 8px', fontSize: 11, cursor: 'pointer' }}>Sem resposta</button>
                    <button onClick={() => { const m = window.prompt('Motivo (opcional):') || ''; agir(c, 'sem_interesse', { motivo: m }); }} style={{ background: '#fff', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 5, padding: '3px 8px', fontSize: 11, cursor: 'pointer' }}>Sem interesse</button>
                    <button onClick={() => agir(c, 'reabrir')} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 5, padding: '3px 8px', fontSize: 11, cursor: 'pointer' }}>↺ Reabrir (volta pra fila)</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <button onClick={() => setModalAvulsa(true)} title="Cria a oportunidade do zero, igual à página Oportunidades — com a régua completa"
            style={{ background: 'none', border: 'none', color: '#0369a1', fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0 }}>
            ➕ Não achou aqui? Lance de forma avulsa
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: oportunidade AVULSA — contato que não está em lista nenhuma ──
// Mesmo lançamento da página Oportunidades: SDR logada + closer obrigatório,
// e a régua completa dispara (grupo, apresentação, tarefa na agenda do closer)
function ModalOpAvulsa({ termo, onFechar, onCriada }) {
  const ehTel = dig(termo || '').length >= 8;
  const [nome, setNome] = useState(ehTel ? '' : (termo || '').trim());
  const [telefone, setTelefone] = useState(ehTel ? (termo || '').trim() : '');
  const [closer, setCloser] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  async function lancar() {
    if (!nome.trim()) return setErro('Informe o nome do cliente.');
    if (!closer) return setErro('Escolha o consultor (closer) que vai atender.');
    setSalvando(true);
    const r = await apiSend('oportunidades', 'POST', {
      nome_cliente: nome.trim(), telefone: telefone.trim(),
      sdr: localStorage.getItem('nomeUsuario') || '', closer, etapa: 'lead',
    }).catch(() => null);
    setSalvando(false);
    if (!r || r.erro) return setErro(r?.erro || 'Falha ao lançar a oportunidade.');
    window.alert(`✓ Oportunidade de ${nome.trim()} lançada! O ${closer.split(' ')[0]} recebe a tarefa e o contato automático.`);
    onCriada();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1010, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 420, maxWidth: '94%', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 4px' }}>➕ Oportunidade avulsa</h2>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 12px' }}>Pra quem não está em lista nenhuma — mesma régua da página Oportunidades.</p>
        <label style={lbl}>Nome do cliente <span style={{ color: '#dc2626' }}>*</span></label>
        <input autoFocus={!nome} value={nome} onChange={e => { setNome(e.target.value); setErro(''); }} placeholder="Ex: PADARIA DO ZÉ" style={{ ...inp, width: '100%', marginBottom: 10 }} />
        <label style={lbl}>Telefone (com DDD)</label>
        <input value={telefone} onChange={e => { setTelefone(e.target.value); setErro(''); }} placeholder="Ex: 83 99999-0000" style={{ ...inp, width: '100%', marginBottom: 10 }} />
        <label style={lbl}>Consultor (closer) que vai atender <span style={{ color: '#dc2626' }}>*</span></label>
        <SelectColaborador apenasClosers value={closer} onChange={v => { setCloser(v); setErro(''); }} placeholder="Escolha o consultor…" style={{ marginBottom: 12, height: 34, fontSize: 13 }} />
        {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={lancar} disabled={salvando} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            {salvando ? 'Lançando…' : '✓ Lançar oportunidade'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Modal: Radar RPI (só Vagner) — gatilhos da revista viram lista quente ──
// ── Seletor de estado com bandeira (miniaturas em /bandeiras/uf.png) ──
// <option> nativo não renderiza imagem, então o dropdown é feito na mão
const UFS = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AM', 'Amazonas'], ['AP', 'Amapá'], ['BA', 'Bahia'], ['CE', 'Ceará'],
  ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'], ['GO', 'Goiás'], ['MA', 'Maranhão'], ['MG', 'Minas Gerais'],
  ['MS', 'Mato Grosso do Sul'], ['MT', 'Mato Grosso'], ['PA', 'Pará'], ['PB', 'Paraíba'], ['PE', 'Pernambuco'],
  ['PI', 'Piauí'], ['PR', 'Paraná'], ['RJ', 'Rio de Janeiro'], ['RN', 'Rio Grande do Norte'], ['RO', 'Rondônia'],
  ['RR', 'Roraima'], ['RS', 'Rio Grande do Sul'], ['SC', 'Santa Catarina'], ['SE', 'Sergipe'], ['SP', 'São Paulo'],
  ['TO', 'Tocantins'],
];

function BandeiraUF({ uf }) {
  return <img src={`/bandeiras/${uf.toLowerCase()}.png`} alt={uf} width={21} height={14}
    style={{ objectFit: 'cover', borderRadius: 2, border: '1px solid rgba(0,0,0,0.15)', display: 'block', flexShrink: 0 }} />;
}

function SeletorUF({ value, onChange }) {
  const [aberto, setAberto] = useState(false);
  const caixaRef = useRef(null);
  useEffect(() => {
    const fora = (e) => { if (caixaRef.current && !caixaRef.current.contains(e.target)) setAberto(false); };
    document.addEventListener('mousedown', fora);
    return () => document.removeEventListener('mousedown', fora);
  }, []);
  const linha = { display: 'flex', alignItems: 'center', gap: 8, padding: '5px 10px', cursor: 'pointer', fontSize: 12.5 };
  return (
    <div ref={caixaRef} style={{ position: 'relative' }}>
      <button onClick={() => setAberto(a => !a)}
        style={{ ...inp, width: 150, display: 'flex', alignItems: 'center', gap: 7, cursor: 'pointer', fontWeight: value ? 700 : 400, borderColor: value ? '#0369a1' : '#b0b8c4', background: value ? '#f0f9ff' : '#fff' }}>
        {value ? <><BandeiraUF uf={value} /><span>{value}</span></> : <span>🇧🇷 Brasil todo</span>}
        <span style={{ marginLeft: 'auto', fontSize: 9, color: '#6b7280' }}>▼</span>
      </button>
      {aberto && (
        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 60, marginTop: 2, background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, boxShadow: '0 10px 30px rgba(0,0,0,0.18)', width: 235, maxHeight: 290, overflowY: 'auto' }}>
          <div onClick={() => { onChange(''); setAberto(false); }}
            style={{ ...linha, fontWeight: !value ? 700 : 400, background: !value ? '#f0f9ff' : '#fff', borderBottom: '1px solid #e8eaed' }}
            onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
            onMouseLeave={e => e.currentTarget.style.background = !value ? '#f0f9ff' : '#fff'}>
            <span style={{ fontSize: 15 }}>🇧🇷</span><strong>Brasil todo</strong>
          </div>
          {UFS.map(([u, nome]) => (
            <div key={u} onClick={() => { onChange(u); setAberto(false); }}
              style={{ ...linha, background: value === u ? '#f0f9ff' : '#fff' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
              onMouseLeave={e => e.currentTarget.style.background = value === u ? '#f0f9ff' : '#fff'}>
              <BandeiraUF uf={u} />
              <strong style={{ color: '#0a1628', width: 24 }}>{u}</strong>
              <span style={{ color: '#6b7280', fontSize: 11.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nome}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Dashboard do Radar: movimentações × estado da revista escolhida ──
// Linha clicável: escolhe o estado e volta pro Radar já filtrado
const ROTULO_CURTO = {
  sozinhos: 'Sozinhos', exigencia: 'Exigência', indeferido: 'Indeferido', oposicao: 'Oposição',
  deferido: 'Deferido', expirado: 'Expirado', perdido: 'Perdido',
};

function ModalDashboardRadar({ rpi, onFechar, onEscolherUf }) {
  const [dados, setDados] = useState(null);
  useEffect(() => {
    apiGet(`sdr/radar/dashboard?rpi=${encodeURIComponent(rpi)}`)
      .then(d => setDados(d.erro ? { erro: d.erro } : d))
      .catch(() => setDados({ erro: 'Falha ao montar o dashboard' }));
  }, [rpi]);

  const th = { padding: '5px 8px', fontSize: 10.5, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.03em', background: '#0a1628', whiteSpace: 'nowrap', textAlign: 'center', position: 'sticky', top: 0 };
  const td = { padding: '3px 8px', fontSize: 12.5, color: '#374151', borderBottom: '1px solid #e8eaed', textAlign: 'center', whiteSpace: 'nowrap' };
  const nomeDe = (uf) => (UFS.find(([u]) => u === uf) || [])[1] || '';

  const cats = dados?.categorias || [];
  const linhas = dados?.linhas || [];
  const totais = {};
  cats.forEach(c => { totais[c.key] = linhas.reduce((s, l) => s + (l[c.key] || 0), 0); });
  const totalGeral = linhas.reduce((s, l) => s + l.total, 0);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 880, maxWidth: '97%', maxHeight: '90vh', overflowY: 'auto', padding: 18, boxShadow: '0 20px 60px rgba(0,0,0,0.35)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>📊 Dashboard — RPI {rpi}</h2>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#6b7280', lineHeight: 1 }}>×</button>
        </div>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 10px' }}>Empresas sem procurador por estado × movimentação. <strong>Clique num estado</strong> pra filtrar o Radar por ele.</p>
        {!dados ? (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: 24, fontSize: 13 }}>Cruzando a revista…</div>
        ) : dados.erro ? (
          <div style={{ textAlign: 'center', color: '#dc2626', padding: 24, fontSize: 13 }}>⚠ {String(dados.erro)}</div>
        ) : (
          <div style={{ border: '1px solid #c8d0da', borderRadius: 6, overflow: 'auto', maxHeight: '68vh' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 640 }}>
              <thead><tr>
                <th style={{ ...th, textAlign: 'left' }}>Estado</th>
                {cats.map(c => <th key={c.key} style={th} title={c.titulo}>{ROTULO_CURTO[c.key] || c.titulo}</th>)}
                <th style={th}>Total</th>
              </tr></thead>
              <tbody>
                {/* Brasil inteiro (totais) */}
                <tr style={{ background: '#f0f4ff' }}>
                  <td style={{ ...td, textAlign: 'left', fontWeight: 800, color: '#0a1628' }}>🇧🇷 Brasil</td>
                  {cats.map(c => <td key={c.key} style={{ ...td, fontWeight: 700 }}>{totais[c.key] || '—'}</td>)}
                  <td style={{ ...td, fontWeight: 800, color: '#0a1628' }}>{totalGeral}</td>
                </tr>
                {linhas.map((l, i) => {
                  const clicavel = l.uf !== '—';
                  return (
                    <tr key={l.uf}
                      onClick={() => clicavel && onEscolherUf(l.uf)}
                      title={clicavel ? `Filtrar o Radar por ${nomeDe(l.uf) || l.uf}` : 'Movimentos sem UF informada na revista'}
                      style={{ background: i % 2 ? '#fafafa' : '#fff', cursor: clicavel ? 'pointer' : 'default' }}
                      onMouseEnter={e => { if (clicavel) e.currentTarget.style.background = '#f0f9ff'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = i % 2 ? '#fafafa' : '#fff'; }}>
                      <td style={{ ...td, textAlign: 'left' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                          {clicavel ? <BandeiraUF uf={l.uf} /> : <span style={{ width: 21 }} />}
                          <strong style={{ color: '#0a1628', width: 24 }}>{l.uf}</strong>
                          <span style={{ color: '#9ca3af', fontSize: 11 }}>{nomeDe(l.uf)}</span>
                        </span>
                      </td>
                      {cats.map(c => (
                        <td key={c.key} style={{ ...td, color: l[c.key] ? '#374151' : '#d1d5db', fontWeight: l[c.key] ? 600 : 400 }}>
                          {l[c.key] || '—'}
                        </td>
                      ))}
                      <td style={{ ...td, fontWeight: 800, color: '#0369a1' }}>{l.total}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Lista do Google Maps: segmento + bairro → fila pronta com telefone ──────
function ModalMaps({ sdrPadrao, sdrs, onFechar, onGerado }) {
  const [segmento, setSegmento] = useState('');
  const [regiao, setRegiao] = useState('');
  const [sdr, setSdr] = useState(sdrPadrao || sdrs[0] || '');
  const [limite, setLimite] = useState(20);
  const [gerando, setGerando] = useState(false);
  const [erro, setErro] = useState('');
  const inp = { width: '100%', padding: '5px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box' };
  const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };

  async function gerar() {
    if (!segmento.trim() || !regiao.trim()) return setErro('Preencha o segmento e o bairro/cidade.');
    setErro('');
    setGerando(true);
    try {
      const r = await apiSend('sdr/listas/maps', 'POST', { segmento: segmento.trim(), regiao: regiao.trim(), sdr, limite });
      if (r.erro) throw new Error(r.erro);
      window.alert(`✓ Lista criada: ${r.inseridos} estabelecimento(s)${r.descartados ? ` (${r.descartados} descartados por já estarem na base)` : ''}`);
      onGerado();
    } catch (e) { setErro(e.message); }
    setGerando(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 420, maxWidth: '95vw', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>🗺️ Lista do Google Maps</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '12px 14px' }}>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 10px' }}>
            Busca ~20 estabelecimentos com <strong>telefone e cidade</strong> — quem já é cliente, está no CRM ou já apareceu em outra lista fica de fora.
          </p>
          <label style={lbl}>Segmento</label>
          <input value={segmento} onChange={e => setSegmento(e.target.value)} placeholder="Ex.: clínicas de estética" style={{ ...inp, marginBottom: 8 }} autoFocus />
          <label style={lbl}>Bairro / Cidade</label>
          <input value={regiao} onChange={e => setRegiao(e.target.value)} placeholder="Ex.: Centro, João Pessoa - PB" style={{ ...inp, marginBottom: 8 }} />
          <label style={lbl}>Tamanho da lista</label>
          <select value={limite} onChange={e => setLimite(parseInt(e.target.value))} style={{ ...inp, marginBottom: 8 }}>
            <option value={20}>20 empresas — uma tarde de fila</option>
            <option value={40}>40 empresas</option>
            <option value={60}>60 empresas — teto do Google por pesquisa</option>
          </select>
          <label style={lbl}>SDR responsável</label>
          <select value={sdr} onChange={e => setSdr(e.target.value)} style={{ ...inp, marginBottom: 12 }}>
            <option value="">Sem dona (distribuir depois)</option>
            {sdrs.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
          {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>{erro}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={gerar} disabled={gerando}
              style={{ background: gerando ? '#e5e7eb' : '#0a1628', color: gerando ? '#9ca3af' : '#fff', border: 'none', borderRadius: 4, padding: '6px 16px', fontWeight: 700, fontSize: 13, cursor: gerando ? 'default' : 'pointer' }}>
              {gerando ? 'Buscando no Google…' : 'Gerar lista'}
            </button>
            <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '6px 14px', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalRadar({ sdrPadrao, onFechar, onGerado }) {
  const [dados, setDados] = useState(null);
  const [ufAplicada, setUfAplicada] = useState('');
  // Revista escolhida ('' = a última); a lista de opções vem do servidor
  const [rpiSel, setRpiSel] = useState('');
  const [rpisDisp, setRpisDisp] = useState([]);
  const [dashAberto, setDashAberto] = useState(false);
  const [categoria, setCategoria] = useState('');
  const [sdr, setSdr] = useState(sdrPadrao || localStorage.getItem('nomeUsuario') || '');
  const [gerando, setGerando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState('');

  const carregar = useCallback(async (ufBusca, rpiBusca) => {
    setDados(null);
    try {
      const q = [ufBusca ? `uf=${encodeURIComponent(ufBusca)}` : '', rpiBusca ? `rpi=${encodeURIComponent(rpiBusca)}` : ''].filter(Boolean).join('&');
      const d = await apiGet(`sdr/radar${q ? `?${q}` : ''}`);
      setDados(d.erro ? { erro: d.erro } : d);
      if (d.rpis) setRpisDisp(d.rpis);
    } catch { setDados({ erro: 'Falha ao consultar o radar' }); }
  }, []);
  useEffect(() => { carregar('', ''); }, [carregar]);

  async function gerar() {
    if (!categoria) return setErro('Escolha uma categoria de gatilho.');
    if (!sdr) return setErro('Escolha a SDR dona da lista.');
    setErro('');
    setGerando(true);
    try {
      const r = await apiSend('sdr/radar/gerar', 'POST', { rpi: dados.rpi, categoria, sdr, uf: ufAplicada });
      if (r.erro) throw new Error(r.erro);
      setResultado(r);
    } catch (e) { setErro(e.message); }
    setGerando(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 520, maxWidth: '96%', maxHeight: '90vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 2px' }}>📡 Radar RPI</h2>
        <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 12px' }}>Empresas <strong>sem procurador</strong> com despacho publicado na revista — leads com prazo correndo.</p>
        {resultado ? (
          <div>
            <p style={{ fontSize: 14, color: '#15803d', fontWeight: 700, margin: '0 0 8px' }}>Lista gerada!</p>
            <p style={{ fontSize: 13, color: '#374151', margin: '0 0 16px' }}><strong>{resultado.nome}</strong><br />{resultado.inseridos} empresas na fila. Os contatos chegam sem telefone — a SDR usa o <strong>🔍 achar telefone</strong> e completa com o ✏️.</p>
            <div style={{ textAlign: 'right' }}>
              <button onClick={onGerado} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Abrir listas</button>
            </div>
          </div>
        ) : !dados ? (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: 24, fontSize: 13 }}>Varrendo a revista…</div>
        ) : dados.erro ? (
          <div style={{ textAlign: 'center', color: '#dc2626', padding: 24, fontSize: 13 }}>⚠ {String(dados.erro)}</div>
        ) : (
          <>
            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginBottom: 12, flexWrap: 'wrap' }}>
              <div>
                <label style={lbl}>Revista</label>
                <select value={dados.rpi} onChange={e => { setRpiSel(e.target.value); setCategoria(''); carregar(ufAplicada, e.target.value); }}
                  style={{ ...inp, width: 185, fontWeight: 600 }}>
                  {(rpisDisp.length ? rpisDisp : [{ numero: dados.rpi, data: dados.data }]).map(r => (
                    <option key={r.numero} value={r.numero}>
                      RPI {r.numero}{r.data ? ` — ${r.data}` : ''}{String(r.numero) === String(dados.ultima) ? ' (última)' : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ flex: 1 }} />
              <div>
                <label style={lbl}>Estado</label>
                {/* Dropdown com bandeira de cada estado (aplica na hora) */}
                <SeletorUF value={ufAplicada} onChange={v => { setUfAplicada(v); carregar(v, rpiSel); }} />
              </div>
              <button onClick={() => setDashAberto(true)} title="Movimentações × estado da revista escolhida"
                style={{ ...inp, cursor: 'pointer', fontWeight: 700, width: 'auto', color: '#0369a1', borderColor: '#7dd3fc', background: '#f0f9ff' }}>
                📊 Dashboard
              </button>
            </div>
            {dashAberto && (
              <ModalDashboardRadar rpi={dados.rpi} onFechar={() => setDashAberto(false)}
                onEscolherUf={(u) => { setDashAberto(false); setUfAplicada(u); carregar(u, rpiSel); }} />
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
              {/* Pacote completo: os 7 gatilhos numa lista só (titular não repete);
                  cada lead mantém o próprio gatilho e a mensagem certa */}
              <div onClick={() => { setCategoria('todas'); setErro(''); }}
                style={{ border: `1.5px ${categoria === 'todas' ? 'solid #0369a1' : 'dashed #7dd3fc'}`, background: categoria === 'todas' ? '#f0f9ff' : '#f8fdff', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', opacity: (dados.todas || 0) === 0 ? 0.45 : 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 800, color: '#0a1628' }}>🎯 Todas as movimentações</span>
                  <span style={{ background: (dados.todas || 0) > 0 ? '#0369a1' : '#9ca3af', color: '#fff', borderRadius: 999, padding: '1px 9px', fontSize: 11.5, fontWeight: 700 }}>{dados.todas || 0}</span>
                </div>
                <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 1 }}>
                  Os 7 gatilhos num pacote só — bom pra estado de pouco volume: mata tudo de uma vez. Cada lead entra com o próprio gatilho e a mensagem certa.
                </div>
              </div>
              {dados.categorias.map(cat => (
                <div key={cat.key} onClick={() => { setCategoria(cat.key); setErro(''); }}
                  style={{ border: `1.5px solid ${categoria === cat.key ? '#0369a1' : '#e5e7eb'}`, background: categoria === cat.key ? '#f0f9ff' : '#fff', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', opacity: cat.total === 0 ? 0.45 : 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{cat.titulo}</span>
                    <span style={{ background: cat.total > 0 ? '#0369a1' : '#9ca3af', color: '#fff', borderRadius: 999, padding: '1px 9px', fontSize: 11.5, fontWeight: 700 }}>{cat.total}</span>
                  </div>
                  <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 1 }}>{cat.desc}</div>
                  {cat.amostra.length > 0 && <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>ex.: {cat.amostra.join(' · ')}</div>}
                </div>
              ))}
            </div>

            <label style={lbl}>SDR dona da lista</label>
            <SelectColaborador value={sdr} onChange={setSdr} placeholder="Selecione a SDR…" style={{ marginBottom: 10, height: 34, fontSize: 13 }} />
            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 10 }}>Gera no máximo 1.000 empresas por lista (1 por titular, mesmo com vários processos).</div>
            {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
              <button onClick={gerar} disabled={gerando} style={{ background: '#0369a1', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: gerando ? 0.6 : 1 }}>{gerando ? 'Gerando…' : '📡 Gerar lista no SDR'}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function ModalImportar({ sdrPadrao, onFechar, onImportado }) {
  const [nome, setNome] = useState('');
  // Vem pré-selecionada a SDR da aba ativa (ou o próprio login)
  const [sdr, setSdr] = useState(sdrPadrao || localStorage.getItem('nomeUsuario') || '');
  const [arquivo, setArquivo] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState('');
  const inputRef = useRef(null);

  async function importar() {
    if (!nome.trim()) return setErro('Dê um nome à lista (ex.: Lava-jatos JP · Julho).');
    if (!arquivo) return setErro('Selecione o arquivo .xlsx ou .csv.');
    setErro('');
    setEnviando(true);
    try {
      const fd = new FormData();
      fd.append('arquivo', arquivo);
      fd.append('nome', nome.trim());
      fd.append('sdr', sdr);
      const res = await fetch('/sdr/listas', { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd });
      const d = await res.json();
      if (!res.ok) throw new Error(d.erro || 'Falha na importação');
      setResultado(d);
    } catch (e) { setErro(e.message); }
    setEnviando(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 420, maxWidth: '94%', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 12px' }}>📥 Importar lista de prospecção</h2>
        {resultado ? (
          <div>
            <p style={{ fontSize: 14, color: '#15803d', fontWeight: 700, margin: '0 0 8px' }}>Lista criada!</p>
            <ul style={{ fontSize: 13, color: '#374151', margin: '0 0 16px', paddingLeft: 18, lineHeight: 1.7 }}>
              <li><strong>{resultado.inseridos}</strong> contatos importados</li>
              {resultado.duplicados > 0 && <li>{resultado.duplicados} repetidos na planilha (ignorados)</li>}
              {resultado.sem_telefone > 0 && <li>{resultado.sem_telefone} linhas sem telefone válido (ignoradas)</li>}
              {resultado.ja_clientes > 0 && <li style={{ color: '#1d4ed8' }}>{resultado.ja_clientes} já são clientes (marcados com ⚠)</li>}
              {resultado.ja_crm > 0 && <li style={{ color: '#7c3aed' }}>{resultado.ja_crm} já estão no CRM (marcados)</li>}
            </ul>
            <div style={{ textAlign: 'right' }}>
              <button onClick={onImportado} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Abrir listas</button>
            </div>
          </div>
        ) : (
          <>
            <label style={lbl}>Nome da lista</label>
            <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Lava-jatos João Pessoa · Julho" style={{ ...inp, width: '100%', marginBottom: 10 }} />
            <label style={lbl}>SDR responsável</label>
            <SelectColaborador value={sdr} onChange={setSdr} placeholder="Selecione a SDR…" style={{ marginBottom: 10, height: 34, fontSize: 13 }} />
            <label style={lbl}>Planilha (.xlsx ou .csv)</label>
            <div onClick={() => inputRef.current && inputRef.current.click()}
              style={{ border: '2px dashed #c8d0da', borderRadius: 8, padding: 16, textAlign: 'center', cursor: 'pointer', color: '#6b7280', fontSize: 13, marginBottom: 4 }}>
              {arquivo ? `📄 ${arquivo.name}` : '📎 Clique para selecionar o arquivo'}
            </div>
            <input ref={inputRef} type="file" accept=".xlsx,.xls,.csv" style={{ display: 'none' }} onChange={e => setArquivo(e.target.files?.[0] || null)} />
            <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 12 }}>Formato: <strong>coluna A = nome do cliente · coluna B = telefone</strong> (com ou sem cabeçalho).</div>
            {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 10 }}>⚠ {erro}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
              <button onClick={importar} disabled={enviando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: enviando ? 0.6 : 1 }}>{enviando ? 'Importando…' : 'Importar'}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
